<section>
    <div class="filter-header">
        <div>
            <p class="filter-title">Filter</p>
        </div>
        <button class="close-button" (click)="closeFilter()" mat-icon-button>
            <mat-icon fontSet="material-symbols-outlined">close</mat-icon>
        </button>
    </div>
    <div class="filter-content">
        <div class="custom-tabs-container">
            <!-- Tab Navigation -->
            <div class="tab-nav">
                <button *ngFor="let tab of tabs; let i = index" class="tab-button" [class.active]="activeTabIndex === i"
                    (click)="selectTab(i)">
                    {{ tab.label }}
                    <mat-icon *ngIf="hasFilterApplied(i)"
                        style="font-size: 19px; width: 16px; height: 16px; margin-left: 4px; color: #51d151;">check</mat-icon>
                </button>
            </div>

            <!-- Tab Content -->
            <div class="tab-content-wrapper">
                <div class="tab-content" *ngIf="activeTabIndex === 0" [@slideDown]>
                    <button class="clear-section-button" (click)="clearDateFilter()">
                        <mat-icon>clear</mat-icon> Clear
                    </button>
                    <div class="filter-options">
                        <div style="display: flex; gap: 16px; margin-bottom: 16px; margin-top: 20px;">
                            <div style="flex: 1;">
                                <span style="font-weight: bold; display: block; margin-bottom: 8px;">ETA</span>
                                <app-date-picker-custom placeholder="Select ETA" [isRange]="false"
                                    [(startDate)]="etaDate" (startDateChange)="onEtaDateChange()">
                                </app-date-picker-custom>
                            </div>
                            <div style="flex: 1;">
                                <span style="font-weight: bold; display: block; margin-bottom: 8px;">ETD</span>
                                <app-date-picker-custom placeholder="Select ETD" [isRange]="false"
                                    [(startDate)]="etdDate" (startDateChange)="onEtdDateChange()">
                                </app-date-picker-custom>
                            </div>
                        </div>
                    </div>
                    <hr>
                    <div class="tab-content" style="margin-top: 16px;">
                        <div style="display: flex; justify-content: space-between; align-items: center;">
                            <span style="font-weight: bold;">PDA processing date</span>
                        </div>
                    </div>
                    <div class="filter-options">
                        <app-date-picker-custom placeholder="Select date range" [isRange]="true"
                            [(startDate)]="pdaStartDate" [(endDate)]="pdaEndDate"
                            (dateChange)="onPdaDateChange($event)">
                        </app-date-picker-custom>
                    </div>
                    <hr>
                    <div class="tab-content" style="margin-top: 16px;">
                        <div style="display: flex; justify-content: space-between; align-items: center;">
                            <span style="font-weight: bold;">FDA processing date</span>
                        </div>
                    </div>
                    <div class="filter-options">
                        <app-date-picker-custom placeholder="Select date range" [isRange]="true"
                            [(startDate)]="fdaStartDate" [(endDate)]="fdaEndDate"
                            (dateChange)="onFdaDateChange($event)">
                        </app-date-picker-custom>
                    </div>




                </div>

                <div class="tab-content" *ngIf="activeTabIndex === 1" [@slideDown]>
                    <button class="clear-section-button" (click)="clearStatusFilter()">
                        <mat-icon>clear</mat-icon> Clear
                    </button>

                    <div class="filter-options">
                        <div class="checkbox-list status-filter-list">

                            <!-- PDA -->
                            <div class="status-group">
                                <div class="status-group-title">PDA</div>

                                <div class="status-chip-wrapper">
                                    <div *ngFor="let status of filteredStatusList">
                                        <div *ngIf="status.status !== 'On-Hold' && status.status !== 'Final Status'"
                                            class="status-filter-chip" [class.selected]="status.pda"
                                            (click)="toggleStatus(status, 'pda')">
                                            <div class="status-filter-text">{{ status.status }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- FDA -->
                            <div class="status-group">
                                <div class="status-group-title">FDA</div>

                                <div class="status-chip-wrapper">
                                    <div *ngFor="let status of filteredStatusList">
                                        <div *ngIf="shouldShowFdaStatus(status)" class="status-filter-chip"
                                            [class.selected]="status.fda" (click)="toggleStatus(status, 'fda')">
                                            <div class="status-filter-text">{{ status.status }}</div>
                                        </div>
                                    </div>
                                </div>

                                <div class="status-group-title final-title">Final Status</div>

                                <div class="status-chip-wrapper">
                                    <div *ngFor="let status of filteredStatusList">
                                        <div *ngIf="status.status === 'Final Status'" class="status-filter-chip"
                                            [class.selected]="status.pda || status.fda"
                                            (click)="toggleStatus(status, 'both')">
                                            <div class="status-filter-text">Final Status</div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div *ngIf="filteredStatusList.length === 0 && statusList.length > 0" class="no-data">
                                <p>No matching statuses found</p>
                            </div>

                            <div *ngIf="statusList.length === 0" class="no-data">
                                <p>No statuses available</p>
                            </div>

                        </div>
                    </div>
                </div>

                <div class="tab-content" *ngIf="activeTabIndex === 2" [@slideDown]>
                    <button class="clear-section-button" (click)="clearPICFilter()">
                        <mat-icon>clear</mat-icon> Clear
                    </button>

                    <div class="filter-options">
                        <div class="search-box" style="margin-top: 25px;" *ngIf="picList.length > 0">
                            <mat-icon class="search-icon-1">search</mat-icon>
                            <input type="text" class="search-input" placeholder="Search PICs..."
                                [(ngModel)]="picSearchText" (input)="filterPICs()">
                        </div>
                        <div class="checkbox-list">
                            <div class="checkbox-item" *ngFor="let pic of filteredPICList">
                                <mat-checkbox [(ngModel)]="pic.selected" disableRipple (change)="onPICChange(pic)"
                                    color="primary" class="custom-mat-checkbox">
                                    {{ pic.user_name }}
                                </mat-checkbox>
                            </div>
                            <div *ngIf="filteredPICList.length === 0 && picList.length > 0" class="no-data">
                                <p>No matching PICs found</p>
                            </div>
                            <div *ngIf="picList.length === 0" class="no-data">
                                <p>No PICs available</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="tab-content" *ngIf="activeTabIndex === 3" [@slideDown]>
                    <button class="clear-section-button" (click)="clearVesselFilter()">
                        <mat-icon>clear</mat-icon> Clear
                    </button>
                    <div class="filter-options">
                        <div class="search-box" style="margin-top: 30px;" *ngIf="vesselList.length > 0">
                            <mat-icon class="search-icon-1">search</mat-icon>
                            <input type="text" class="search-input" placeholder="Search vessels..."
                                [(ngModel)]="vesselSearchText" (input)="filterVessels()">
                        </div>
                        <div class="checkbox-list">
                            <div class="checkbox-item" *ngFor="let vessel of filteredVesselList">
                                <mat-checkbox [(ngModel)]="vessel.selected" disableRipple
                                    (change)="onVesselChange(vessel)" color="primary" class="custom-mat-checkbox">
                                    {{ vessel.name }}
                                </mat-checkbox>
                            </div>
                            <div *ngIf="filteredVesselList.length === 0 && vesselList.length > 0" class="no-data">
                                <p>No matching vessels found</p>
                            </div>
                            <div *ngIf="vesselList.length === 0" class="no-data">
                                <p>No vessels available</p>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- TAB 4: SEGMENT -->
<div class="tab-content" *ngIf="activeTabIndex === 4" [@slideDown]>
    <button class="clear-section-button" (click)="clearSegmentFilter()">
        <mat-icon>clear</mat-icon> Clear
    </button>
    <div class="filter-options">
        <div class="search-box" style="margin-top: 30px;" *ngIf="segmentList.length > 0">
            <mat-icon class="search-icon-1">search</mat-icon>
            <input type="text" class="search-input" placeholder="Search segments..."
                [(ngModel)]="segmentSearchText" (input)="filterSegments()">
        </div>
        <div class="checkbox-list">
            <div class="checkbox-item" *ngFor="let seg of filteredSegmentList">
                <mat-checkbox [(ngModel)]="seg.selected" disableRipple
                    (change)="onSegmentChange(seg)" color="primary" class="custom-mat-checkbox">
                    {{ seg.name }}
                </mat-checkbox>
            </div>
            <div *ngIf="filteredSegmentList.length === 0 && segmentList.length > 0" class="no-data">
                <p>No matching segments found</p>
            </div>
            <div *ngIf="segmentList.length === 0" class="no-data">
                <p>No segments available</p>
            </div>
        </div>
    </div>
</div>
                <div class="tab-content" *ngIf="activeTabIndex === 5" [@slideDown]>
                    <button class="clear-section-button" (click)="clearPortFilter()">
                        <mat-icon>clear</mat-icon> Clear
                    </button>
                    <div class="filter-options">
                        <div class="search-box" style="margin-top: 30px;" *ngIf="portList.length > 0">
                            <mat-icon class="search-icon-1">search</mat-icon>
                            <input type="text" class="search-input" placeholder="Search ports..."
                                [(ngModel)]="portSearchText" (input)="filterPorts()">
                        </div>
                        <div class="checkbox-list">
                            <div class="checkbox-item" *ngFor="let port of filteredPortList">
                                <mat-checkbox [(ngModel)]="port.selected" disableRipple (change)="onPortChange(port)"
                                    color="primary" class="custom-mat-checkbox">
                                    {{ port.name }}
                                </mat-checkbox>
                            </div>
                            <div *ngIf="filteredPortList.length === 0 && portList.length > 0" class="no-data">
                                <p>No matching ports found</p>
                            </div>
                            <div *ngIf="portList.length === 0" class="no-data">
                                <p>No ports available</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="tab-content" *ngIf="activeTabIndex === 6" [@slideDown]>
                    <button class="clear-section-button" (click)="clearCountryFilter()">
                        <mat-icon>clear</mat-icon> Clear
                    </button>
                    <div class="filter-options">
                        <div class="search-box" style="margin-top: 30px;" *ngIf="countryList.length > 0">
                            <mat-icon class="search-icon-1">search</mat-icon>
                            <input type="text" class="search-input" placeholder="Search countries..."
                                [(ngModel)]="countrySearchText" (input)="filterCountries()">
                        </div>
                        <div class="checkbox-list">
                            <div class="checkbox-item" *ngFor="let country of filteredCountryList">
                                <mat-checkbox [(ngModel)]="country.selected" disableRipple
                                    (change)="onCountryChange(country)" color="primary" class="custom-mat-checkbox">
                                    {{ country.country_name }}
                                </mat-checkbox>
                            </div>
                            <div *ngIf="filteredCountryList.length === 0 && countryList.length > 0" class="no-data">
                                <p>No matching countries found</p>
                            </div>
                            <div *ngIf="countryList.length === 0" class="no-data">
                                <p>No countries available</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="tab-content" *ngIf="activeTabIndex === 7" [@slideDown]>
                    <button class="clear-section-button" (click)="clearPortAgentFilter()">
                        <mat-icon>clear</mat-icon> Clear
                    </button>

                    <div class="filter-options">
                        <div class="search-box" style="margin-top: 30px;" *ngIf="portAgentList.length > 0">
                            <mat-icon class="search-icon-1">search</mat-icon>
                            <input type="text" class="search-input" placeholder="Search port agents..."
                                [(ngModel)]="searchText" (input)="filterPortAgents()">
                        </div>
                        <div class="checkbox-list">
                            <div class="checkbox-item" *ngFor="let agent of filteredPortAgentList">
                                <mat-checkbox [(ngModel)]="agent.selected" disableRipple
                                    (change)="onPortAgentChange(agent)" color="primary" class="custom-mat-checkbox">
                                    {{ agent.company_name }}
                                </mat-checkbox>
                            </div>
                            <div *ngIf="filteredPortAgentList.length === 0 && portAgentList.length > 0" class="no-data">
                                <p>No matching port agents found</p>
                            </div>
                            <div *ngIf="portAgentList.length === 0" class="no-data">
                                <p>No port agents available</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="tab-content" *ngIf="activeTabIndex === 8" [@slideDown]>
                    <button class="clear-section-button" (click)="clearClientFilter()">
                        <mat-icon>clear</mat-icon> Clear
                    </button>
                    <div class="filter-options">
                        <div class="search-box" style="margin-top: 30px;" *ngIf="clientList.length > 0">
                            <mat-icon class="search-icon-1">search</mat-icon>
                            <input type="text" class="search-input" placeholder="Search clients..."
                                [(ngModel)]="clientSearchText" (input)="filterClients()">
                        </div>
                        <div class="checkbox-list">
                            <div class="checkbox-item" *ngFor="let client of filteredClientList">
                                <mat-checkbox [(ngModel)]="client.selected" disableRipple
                                    (change)="onClientChange(client)" color="primary" class="custom-mat-checkbox">
                                    {{ client.name }}
                                </mat-checkbox>
                            </div>
                            <div *ngIf="filteredClientList.length === 0 && clientList.length > 0" class="no-data">
                                <p>No matching clients found</p>
                            </div>
                            <div *ngIf="clientList.length === 0" class="no-data">
                                <p>No clients available</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="tab-content" *ngIf="activeTabIndex === 9" [@slideDown]>
                    <button class="clear-section-button" (click)="clearVoyageFilter()">
                        <mat-icon>clear</mat-icon> Clear
                    </button>
                    <div class="filter-options">
                        <div *ngIf="selectedVoyages.length > 0"
                            style="display: flex; flex-wrap: wrap; align-content: flex-start; gap: 8px; margin-top: 20px; margin-bottom: 16px; max-height: 235px; overflow-y: auto;">
                            <mat-chip *ngFor="let voyage of selectedVoyages" (removed)="removeVoyage(voyage)">
                                {{ voyage }}
                                <mat-icon matChipRemove>cancel</mat-icon>
                            </mat-chip>
                        </div>
                        <mat-form-field appearance="outline" style="width: 100%;">
                            <mat-label>Search voyages</mat-label>
                            <input type="text" matInput [formControl]="voyageControl" [matAutocomplete]="autoVoyage"
                                (keydown.enter)="addCustomVoyage()">
                            <mat-autocomplete #autoVoyage="matAutocomplete" (optionSelected)="onVoyageSelected($event)">
                                <mat-option *ngFor="let voyage of filteredVoyageList" [value]="voyage.name">
                                    {{ voyage.name }}
                                </mat-option>
                                <mat-option *ngIf="voyageControl.value && filteredVoyageList.length === 0"
                                    [value]="voyageControl.value">
                                    Add "{{ voyageControl.value }}"
                                </mat-option>
                            </mat-autocomplete>
                        </mat-form-field>
                    </div>
                </div>

                <div class="tab-content" *ngIf="activeTabIndex === 10" [@slideDown]>
                    <button class="clear-section-button" (click)="clearLossPreventionFilter()">
                        <mat-icon>clear</mat-icon> Clear
                    </button>
                    <div class="filter-options">
                        <div class="checkbox-list" style="margin-top: 30px;">
                            <div *ngFor="let lp of lossPreventionList"
                                style="margin-bottom: 16px; padding: 12px; border: 1px solid #e5e7eb; border-radius: 8px;">
                                <div style="display: flex; align-items: center; margin-bottom: 8px;">
                                    <mat-checkbox [(ngModel)]="lp.enabled" (change)="onLossPreventionChange()"
                                        color="primary" class="custom-mat-checkbox">
                                        {{ lp.type }}
                                    </mat-checkbox>
                                </div>
                                <div *ngIf="lp.enabled" style="display: flex; gap: 40px; margin-left: 32px;">
                                    <div style="width: 100px;">
                                        <label
                                            style="font-size: 12px; color: #6b7280; display: block; margin-bottom: 4px;">Min</label>
                                        <input type="number" [(ngModel)]="lp.min" (input)="onLossPreventionChange()"
                                            placeholder="Min value"
                                            style="width: 100%; padding: 8px; border: 1px solid #d1d5db; border-radius: 4px;">
                                    </div>
                                    <div style="width: 100px;">
                                        <label
                                            style="font-size: 12px; color: #6b7280; display: block; margin-bottom: 4px;">Max</label>
                                        <input type="number" [(ngModel)]="lp.max" (input)="onLossPreventionChange()"
                                            placeholder="Max value"
                                            style="width: 100%; padding: 8px; border: 1px solid #d1d5db; border-radius: 4px;">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="tab-content" *ngIf="activeTabIndex === 11" [@slideDown]>
                    <button class="clear-section-button" (click)="clearOverDueFilter()">
                        <mat-icon>clear</mat-icon> Clear
                    </button>
                    <div class="filter-options">
                        <div class="checkbox-list" style="margin-top: 30px;">
                            <div *ngFor="let od of overDueList"
                                style="margin-bottom: 16px; padding: 12px; border: 1px solid #e5e7eb; border-radius: 8px;">
                                <div style="font-weight: 500; color: #374151; margin-bottom: 8px;">
                                    {{ od.type }}
                                </div>
                                <div style="display: flex; gap: 40px;">
                                    <div style="width: 100px;">
                                        <label
                                            style="font-size: 12px; color: #6b7280; display: block; margin-bottom: 4px;">Min</label>
                                        <input type="number" [(ngModel)]="od.min" (input)="onOverDueChange()"
                                            placeholder="Min value"
                                            style="width: 100%; padding: 8px; border: 1px solid #d1d5db; border-radius: 4px;">
                                    </div>
                                    <div style="width: 100px;">
                                        <label
                                            style="font-size: 12px; color: #6b7280; display: block; margin-bottom: 4px;">Max</label>
                                        <input type="number" [(ngModel)]="od.max" (input)="onOverDueChange()"
                                            placeholder="Max value"
                                            style="width: 100%; padding: 8px; border: 1px solid #d1d5db; border-radius: 4px;">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="clear-section">
        <button class="clear-button" (click)="clearAllFilters()">
            Clear All
        </button>
        <button class="apply-button" (click)="applyFilters()">
            Apply Filters
        </button>
    </div>
</section>